import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from '@redux-devtools/extension';
import { createEpicMiddleware } from 'redux-observable';
// import { reactPerfTool } from 'react-perf-devtool';
import LogRocket from 'logrocket';
import { BehaviorSubject } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { rootEpic } from '../epic';
import { CustomMiddleware } from '../store/custom-middleware';
import { LogService } from '../services/log-service';

import { createRootReducer } from './reducer';

const logrocketMiddleware = process.env.NODE_ENV === 'development' ? [] : [LogRocket.reduxMiddleware()];
const devToolsConfig = { name: 'ShipStationDevToolsConfig' };
const composeEnhancers = composeWithDevTools(devToolsConfig);

// if (process.env.NODE_ENV === 'development') {
//   reactPerfTool(); NOTE: leaving this commented out as it can really bog down chrome
// }

const epic$ = new BehaviorSubject(rootEpic);
const hotModuleReloadEpic = (action$, state$, dependencies) => {
  const getState = () => state$.value;
  return epic$.pipe(
    switchMap((epic) => epic(action$, { getState, state$ }, dependencies)),
    catchError((error, stream) => {
      // oxlint-disable-next-line no-console
      console.error('Uncaught Epic Exception', error.stack);
      LogService.logError(error);
      return stream;
    }),
  );
};

export function configureStore(initialState, history) {
  const rootReducer = createRootReducer();
  const epicMiddleware = createEpicMiddleware({
    dependencies: { push: history.push, history },
  });
  const middleware = [];
  middleware.push(epicMiddleware);
  const store = createStore(
    rootReducer,
    initialState,
    composeEnhancers(applyMiddleware(...middleware, ...CustomMiddleware, ...logrocketMiddleware)),
  );

  epicMiddleware.run(hotModuleReloadEpic);

  if (import.meta.hot) {
    import.meta.hot.accept('./reducer', async (newModule) => {
      if (newModule) {
        const nextRootReducer = newModule.createRootReducer();
        store.replaceReducer(nextRootReducer);
      }
    });

    import.meta.hot.accept('../epic', async (newModule) => {
      if (newModule) {
        const nextRootEpic = newModule.rootEpic;
        epic$.next(nextRootEpic);
      }
    });
  }
  return store;
}
